/**
 * @generated SignedSource<<5a4d4b3cf8d902c51703b41b7026865b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type DiscountTypeKind = "System" | "User";
import { FragmentRefs } from "relay-runtime";
export type discountActionsTable_DiscountActionFragment$data = {
  readonly discountType: {
    readonly kind: DiscountTypeKind;
  };
  readonly id: string;
  readonly isReductible: boolean;
  readonly percent: any;
  readonly title: string;
  readonly " $fragmentType": "discountActionsTable_DiscountActionFragment";
};
export type discountActionsTable_DiscountActionFragment$key = {
  readonly " $data"?: discountActionsTable_DiscountActionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"discountActionsTable_DiscountActionFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "discountActionsTable_DiscountActionFragment"
};

(node as any).hash = "6bbda0644b1e30e22a6351620ccbaf8b";

export default node;
